<template lang="pug">
div.container-img
  p(:style="{ color: '#B01000'}", v-if='this.imgErrorShowText === true') {{imgErrorText}}  {{getThumbnail()}}
  img.image(:src="baseUrl+url" v-if='this.imgError === false')
</template>
<script>

  export default {
    props: {
      url: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        getThumbnail: () =>{
          var image = new Image(); 
          image.src = `${this.baseUrl}${this.url}`;
          setTimeout(() => {
            if (image.width == 0) {
              this.imgError = true
              this.imgErrorShowText = true
              this.imgErrorText = 'Error retrieveing image thumbnail'
            }else{
              this.imgErrorShowText = false
              this.calculateRatio(image)
            }
          }, 1000);
        },
        calculateRatio: (image)=>{
          if ((image.width / image.height) >= 1.70 && (image.width / image.height) <= 1.79) {
            // alert('ratio accepted 16:9')
            this.imgErrorShowText = false
          }else{
            this.imgErrorShowText = true
            this.imgErrorText = "WARNING!! The ratio of this series poster is not 16:9 and it won't work on Roku"
          }
        },
        baseUrl: `https://s3.us-east-1.amazonaws.com/${process.env.IMAGES_BUCKET_NAME}/`,
        imgError: false,
        imgErrorShowText: false,
        imgErrorText: ''
      };
    },
  };

</script>

<style lang="scss" scoped>
  .container-img{
    justify-items: center;
    align-items: center;
    margin-bottom: 20px;
  }
  .image{
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/shared-components/SerieThumbnail.vue